<t4-list-view #listVw [options]="listOptions" (onDataRequest)="doPage($event)">
  <ng-container *t4ListItem="let item">
    @switch (item.ProductType) {
      @case (ProductTypeEnum.Ticket) {
        @if (item.PassePartoutName == null) {
          <td>
            {{item.EventDate | localDateTime }} - {{item.EventName}}
          </td>
        }
        @if (item.PassePartoutName != null) {
          <td>{{ item.PassePartoutName | replaceOnEmpty:''}}</td>
        }
        <td>{{item.ParentSectionName}} / {{item.RowNumber | replaceOnEmpty}}
        / {{item.SeatNumber | replaceOnEmpty}}</td>
        <td>
          <t4-customer-identification-control [isIbaActive]="false" [showCustomerNumber]="true" [customer]="constructCustomerIdentificationModel(item)"></t4-customer-identification-control>
        </td>
        <td><a (click)="routeToOrder(item.OriginalOrderId)" class="clickable-customer-name">{{item.OriginalOrderId}}</a></td>
        <td>{{ item.OriginalOrderDate | localDateTime }}</td>
      }
      @case (ProductTypeEnum.DeliveryMethod) {
        <td>{{'T4.ORDERDETAILS.ORDERLINES.DELIVERY-COST' | translate}}</td>
        <td colspan="4"></td>
      }
      @case (ProductTypeEnum.PaymentMethod) {
        <td>{{'T4.ORDERDETAILS.ORDERLINES.MARKUP-PAYMENTMETHOD' | translate}}</td>
        <td colspan="4"></td>
      }
      @default {
        <td colspan="5">
          <span class="fas fa-exclamation-triangle"></span>
          <span class="mx-2">{{'T4.ORDERDETAILS.ORDERLINES.CANNOTSHOWLINE' | translate}}</span>
          <span class="fas fa-exclamation-triangle"></span>
        </td>
      }
    }
  </ng-container>
</t4-list-view>
